module.exports = __webpack_public_path__ + "static/media/500014.f2f9cd0d.svg";